
function changeCheckboxvalue(event) {
    if (event.target.tagName.toLowerCase() === 'a') {
        if ((event.type == 'keydown' && event.which == 32) || (event.type == 'keydown' && event.which == 13) || event.type == 'click') {
            window.location = event.target.href;
        }
    }

    if ((event.type == 'keydown' && event.which == 32) || (event.type == 'keydown' && event.which == 13) || event.type == 'click') {
        let item = $('.checkBxDiv-checkbox #newsletter-RegisterForm-consent');
        let parentItem = $('.checkBxDiv-checkbox');
        switch (item.attr('aria-checked')) {
            case "true":
                item.attr('aria-checked', "false");
                item.attr('checked', "false");
                item.removeAttr('checked');
                item.addClass("error-msg");
                $('.valid-consent-msg span').addClass("error-msg");
                parentItem.addClass("error-msg");
                parentItem.attr('aria-checked', "false");
                break;
            case "false":
                item.attr('aria-checked', "true");
                item.attr('checked', "true");
                item.removeClass("error-msg");
                parentItem.removeClass("error-msg");
                $('.valid-consent-msg span').removeClass("error-msg");
                parentItem.attr('aria-checked', "true");
                break;
        }
        event.stopPropagation();
        event.preventDefault();
    }
}

function isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}

setTimeout(() => {
    jQuery(document).on("change", "#newsletter-RegisterForm-email", function (e) {
        jQuery("#newsletter-RegisterForm .input-error-message").stop(true, true).fadeOut();
        jQuery("#newsletter-RegisterForm .input-success-message").stop(true, true).fadeOut();
    });

    var pdf_store_access_token = document.getElementById("pdf_store_access_key").value;
    var pdf_api_endpoint_url = document.getElementById("pdf_endpoint_url").value;
    var pdf_api_domain_url = pdf_api_endpoint_url;
    var pdf_shop_token = pdf_store_access_token;
    var pdf_shop_url = Shopify.shop;

    if (jQuery('html').attr('lang') == 'es') {
        var email_err_required = "Proporcione su dirección de correo electrónico";
        var email_err_valid = "Su dirección de correo electrónico debe tener el formato nombre@dominio.com";
        var dob_err_required = "Proporcione su fecha de nacimiento";
        var dob_err_valid_minAge = "Debes tener 21 años o más para inscribirte.";
        var dob_err_valid_maxAge = "Por favor, introduzca un año válido.";
        var dob_err_valid_dateFormat = "Por favor, introduzca una fecha válida en formato MM/DD/YYYY";
        var zip_err_required = "Proporcione su código postal";
        var zip_err_valid = "Proporcione un código postal válido.";
        var consent_err_required = "Marque la casilla de consentimiento antes de enviar";
        var submit_success_msg = "Gracias por suscribirse!";
        var submit_failure_msg = "Hubo un error. Por favor, inténtelo de nuevo más tarde.";
    }
    else {
        var email_err_required = "Please provide your Email Address";
        var email_err_valid = "Your email address must be in the format of name@domain.com";
        var dob_err_required = "Please provide your Date Of Birth";
        var dob_err_valid_minAge = "You must be 21 years or older to sign up.";
        var dob_err_valid_maxAge = "Please enter a valid year.";
        var dob_err_valid_dateFormat = "Please enter a valid date in MM/DD/YYYY format";
        var zip_err_required = "Please provide your Zip Code";
        var zip_err_valid = "Please provide a valid zipcode.";
        var consent_err_required = "Please check the consent box before submitting";
        var submit_success_msg = "Thank You for Subscribing!";
        var submit_failure_msg = "There was an error. Please try again later.";
    }

    jQuery("#newsletter-RegisterForm")
        .submit(function (e) {
            e.preventDefault();
            jQuery(".validation").html("");
            jQuery(".full-input-floating-newsletter").removeClass("error-msg");
            jQuery("#newsletter-RegisterForm .input-error-message").html('').show();
            jQuery("#newsletter-RegisterForm .input-success-message").html('').show();
        })
        .validate({
            errorElement: 'span',
            errorClass: 'custom-error',
            rules: {
                email: {
                    required: true,
                    email: true,
                    emailValidate: true,
                },
                birthdate: {
                    required: true,
                    dateFormat: true,
                    minAge: 21,
                    maxAge: 1910,
                },
                zip: {
                    required: true,
                    zipcode: true,
                },
                consent: "required"
            },
            messages: {
                email: {
                    required: email_err_required,
                    email: email_err_valid
                },
                birthdate: {
                    required: dob_err_required,
                },
                zip: {
                    required: zip_err_required,
                },
                consent: consent_err_required
            },
            invalidHandler: function () {
                jQuery(this).find(":input.error-msg:first").focus();
            },
            errorPlacement: function (error, element) {
                jQuery("#" + element.attr("id"))
                    .parent()
                    .addClass("error-msg");
                if (
                    element.attr("name") == "email" &&
                    jQuery.trim(jQuery(".validation").html()) == ""
                ) {
                    error.appendTo(jQuery(".validation"));
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        $('#newsletter-RegisterForm span.error-msg').css("padding-bottom", "2px");

                    }

                    $("#newsletter-RegisterForm-birthdate-error").hide();
                    $("#newsletter-RegisterForm-zip-error").hide();
                    $("#newsletter-RegisterForm-consent-error").hide();
                } else if (
                    element.attr("name") == "birthdate" &&
                    $.trim($(".valid-date").html()) == ""
                ) {
                    error.appendTo($(".valid-date"));
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        $('#newsletter-RegisterForm span.error-msg').css("padding-bottom", "2px");

                    }
                    $("#newsletter-RegisterForm-email-error").hide();
                    $("#newsletter-RegisterForm-zip-error").hide();
                    $("#newsletter-RegisterForm-consent-error").hide();
                } else if (
                    element.attr("name") == "zip" &&
                    $.trim($(".valid-zipcode").html()) == ""
                ) {
                    error.appendTo($(".valid-zipcode"));
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        $('#newsletter-RegisterForm span.error-msg').css("padding-bottom", "2px");
                    }
                    $("#newsletter-RegisterForm-email-error").hide();
                    $("#newsletter-RegisterForm-birthdate-error").hide();
                    $("#newsletter-RegisterForm-consent-error").hide();
                } else if (
                    element.attr("name") == "consent" &&
                    $.trim($(".valid-consent-msg").html()) == ""
                ) {
                    error.appendTo($(".valid-consent-msg"));
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        $('#newsletter-RegisterForm span.error-msg').css("padding-bottom", "2px");

                    }
                    $("#newsletter-RegisterForm-email-error").hide();
                    $("#newsletter-RegisterForm-birthdate-error").hide();
                    $("#newsletter-RegisterForm-zip-error").hide();
                }
            },
            submitHandler: function (form) {
                jQuery('#newsletter-RegisterForm .btn-submit').attr("disabled", 'disabled');
                var inputs = $("#newsletter-RegisterForm").serializeArray();
                var final_values_pdf = {};
                $.each(inputs, function (index, value) {
                    if (value['name'] == 'birthdate') {
                        var dobArr = value['value'].split(' / ');
                        final_values_pdf['dob'] = dobArr[2] + '-' + dobArr[0] + '-' + dobArr[1];
                    }
                    else {
                        final_values_pdf[value['name']] = value['value'];
                    }
                });
                if (final_values_pdf['consent']) {
                    final_values_pdf['consent'] = true;
                } else {
                    final_values_pdf['consent'] = false;
                }
                final_values_pdf["shop_url"] = pdf_shop_url;

                var data = JSON.stringify(final_values_pdf);
                var settings = {
                    "url": pdf_api_domain_url + "/v2/salesforce/pacificouser",
                    "method": "POST",
                    "timeout": 0,
                    "headers": {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + pdf_shop_token
                    },
                    "data": data
                };

                $.ajax(settings).done(function (response) {
                    if (window.matchMedia('(max-width: 768px)').matches) {
                        $('#newsletter-RegisterForm span.error-msg').css("padding-bottom", "6px");

                    }
                    jQuery("#newsletter-RegisterForm .input-success-message").html(submit_success_msg).show();
                    jQuery("#newsletter-RegisterForm")[0].reset();
                    jQuery("#newsletter-RegisterForm-birthdate").attr('placeholder', jQuery('#date-placeholder').val());
                    jQuery('#newsletter-RegisterForm-consent').attr('checked', false);
                    jQuery("#newsletter-RegisterForm .input-success-message").fadeOut(6000);
                    jQuery("#newsletter-RegisterForm-email").focus();
                
                    setTimeout(() => {
                        jQuery('#newsletter-RegisterForm .btn-submit').removeAttr('disabled');
                    }, 5000);
                }).fail(function (xhr, status, error) {
                    console.log(error);
                    jQuery("#newsletter-RegisterForm .input-error-message").html(submit_failure_msg).show();
                    //jQuery("#newsletter-RegisterForm .input-error-message").fadeOut(6000);
                    setTimeout(() => {
                        jQuery('#newsletter-RegisterForm .btn-submit').removeAttr('disabled');
                    }, 5000);
                });

                return false;
            },
        });
    $('input[type="checkbox"]').on('keypress', function (event) {
        if (event.which === 13) {
            this.checked = !this.checked;
        }
    });

    $.validator.addMethod(
        "minAge",
        function (value, element, min) {
            var date = value.split(" / ");
            var m = parseInt(date[0], 10),
                d = parseInt(date[1], 10),
                y = parseInt(date[2], 10);
            var today = new Date();
            var birthDate = new Date(y, m - 1, d);

            var age = today.getFullYear() - birthDate.getFullYear();

            if (age > min + 1) {
                return true;
            }

            var m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age >= min;
        },
        dob_err_valid_minAge
    );

    $.validator.addMethod(
        "maxAge",
        function (value, element, max) {
            var date = value.split(" / ");
            var m = parseInt(date[0], 10),
                d = parseInt(date[1], 10),
                y = parseInt(date[2], 10);

            return y >= max;
        },
        dob_err_valid_maxAge
    );

    $.validator.addMethod(
        "dateFormat",
        function (value, element) {
            var date = value.split(" / ");
            var month = date[0];
            var day = parseInt(date[1], 10);
            var year = date[2];
            var calendarMonth31Days = [4, 6, 9, 11];
            var curMon = month + 1;

            if (parseInt(day) == 31 && calendarMonth31Days.includes(parseInt(month))) {
                return false;
            }
            if (day == '00' || month == '00') {
                return false;
            }

            if (month == "02") {
                if (day > 29) {
                    return false;
                }
                if (day > 29 && year % 4 == 0) {
                    return false;
                }
                if (day == 29 && year % 4 != 0) {
                    return false;
                }
            }

            if (day > 31) {
                return false;
            }
            if (month > 12) {
                return false;
            }
            return /^\d{1,2}\s\/\s\d{1,2}\s\/\s\d{4}$/.test(value);
        },
        dob_err_valid_dateFormat
    );

    jQuery.validator.addMethod("emailValidate", function (value, element) {
        //return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(value);
        return this.optional(element) || /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/i.test(value);
    }, email_err_valid);

    $.validator.addMethod("zipcode", function (value, element) {
        return this.optional(element) || /^\d{5}(?:-\d{4})?$/.test(value);
    }, zip_err_valid);

    jQuery(".full-input-floating-newsletter input").focus(function () {
        jQuery(this).closest('.full-input-floating-newsletter').addClass('active');
    });

    jQuery(".full-input-floating-newsletter input").blur(function () {
        if (jQuery.trim(jQuery(this).val()) == '') {
            jQuery(this).closest('.full-input-floating-newsletter').removeClass('active');
        }
    });

    jQuery("#newsletter-RegisterForm-birthdate").focus(function () {
        var v = this.value;
        if (v.length == 0) {
            jQuery(".dob-div-input label").css("display", "block");
        }
    });

    jQuery("#newsletter-RegisterForm-birthdate").blur(function () {
        var v = this.value;
        if (v == '') {
            jQuery("#newsletter-RegisterForm-birthdate").attr('placeholder', jQuery('#date-placeholder').val());
            jQuery('.dob-div-input label').css('display', 'none');
        }
    });

    jQuery(document).on("keyup", "#newsletter-RegisterForm-birthdate", function (e) {
        var v = this.value;
        if (v.length != 0) {
            jQuery('.dob-div-input label').css('display', 'none');
        }
        if (e.keyCode != 8) {
            if (v.match(/^\d{2}$/) !== null) {
                this.value = v + ' / ';
            } else if (v.match(/^\d{2}\s\/\s\d{2}$/) !== null) {
                this.value = v + ' / ';
            }
        }
    });

    jQuery('.dob-div-input label').click(function () {
        jQuery('#newsletter-RegisterForm-birthdate').focus();
    });

    jQuery('.dob-div-input label').hover(function () {
        jQuery('#newsletter-RegisterForm-birthdate').focus();
        jQuery('.dob-div-input label').css('cursor', 'auto');
    });
}, 5000);

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

if (window.location.href.indexOf("buy") > -1) {
    (function ($) {
        $(document).ready(function () {
            if (!$('.product_locator').isInViewport()) {
                var flag = 0;
                if ($("#seltzerFlag").length > 0) {
                    flag = $("#seltzerFlag").val();
                }
                if (flag == 1) {
                    setTimeout(function () {
                        $('html, body').animate({
                            'scrollTop': $('.product_locator').offset().top + 200
                        }, 1500);
                    }, 200);
                } else {
                    setTimeout(function () {
                        $('html, body').animate({
                            'scrollTop': $('.product_locator').offset().top - 100
                        }, 1500);
                    }, 200);
                }
            }

        });
    })(jQuery);
}